import * as React from 'react';

function SvgPayoutPlanAffectedYes(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#payout-plan-affected-yes_svg__clip0_8120_35865)">
        <path d="M0 0h14v14H0z" />
        <path
          d="M11.593 1.956a.137.137 0 010 .213L9.63 3.753a.137.137 0 01-.222-.106v-1.09H4.376v-.985h5.032V.478c0-.115.133-.179.222-.107l1.963 1.585zM.653 11.124a.137.137 0 010-.213l1.963-1.585a.137.137 0 01.223.107v1.095h5.158v.984H2.84v1.09a.137.137 0 01-.223.106L.653 11.124zM5.785 3.514a.137.137 0 00-.137.136v.337c-.399.09-.697.27-.91.495-.284.3-.382.651-.382.868 0 .211.016.596.32.949.294.34.782.564 1.51.677.544.085.784.237.881.34.08.084.096.167.08.267-.025.146-.113.27-.287.369a1.52 1.52 0 01-.739.17 1.47 1.47 0 01-.568-.144.52.52 0 01-.225-.182c-.039-.065-.096-.13-.172-.13h-.71c-.076 0-.138.061-.13.136.056.553.454.884.796 1.056.177.088.364.15.536.189v.373c0 .076.062.137.137.137h1.012a.137.137 0 00.137-.137v-.434a2.11 2.11 0 00.415-.18c.374-.214.684-.564.768-1.058.06-.355-.01-.766-.335-1.11-.308-.324-.793-.533-1.446-.635-.621-.096-.84-.261-.915-.348-.065-.075-.08-.154-.08-.305 0 .008 0 .007.002 0a.454.454 0 01.111-.192c.091-.097.298-.243.766-.25.368-.005.561.115.664.22a.57.57 0 01.112.166c.03.069.096.131.172.131h.71c.076 0 .138-.06.129-.136-.056-.453-.388-1.024-1.073-1.258v-.38a.137.137 0 00-.137-.137H5.785zM13.137 8.944h.641c.089 0 .14.102.088.174l-2.88 3.992a.436.436 0 01-.707 0l-1.703-2.362a.11.11 0 01.089-.174h.641c.14 0 .272.069.354.182l.973 1.35 2.15-2.98a.436.436 0 01.354-.182z"
          fill="#3BC56F"
        />
      </g>
      <defs>
        <clipPath id="payout-plan-affected-yes_svg__clip0_8120_35865">
          <path d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgPayoutPlanAffectedYes;
